
import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
//   import {faker} from 'faker';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export const options = {
 
  plugins: {
    legend: {
      position: 'top',
      labels:{
          font:{
              family:"Sora"
          }
      }
    },
    title: {
      display: true,
      text: 'Chart Based On Selected Indicators',
      font:{
          family:"Sora"
      }
      
    },
  },
};

const labels = ['S0', 'S1', 'S2', 'S3', 'S4', 'S5', 'S6','S7','S8','S9','S10'];

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}

export const data = {
  labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: labels.map(() => getRandomInt(0, 100)),
      backgroundColor: '#FF7345',
      maxBarThickness:20,
     
    },
  
  ],
};

const Activities = () => {
  return (
    <div style={{width:"70%",display:"flex",justifyContent:"center"}}>
      <Bar options={options} data={data}  />
    </div>
  );
};

export default Activities;
